/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { useTranslation } from "react-i18next";

import { assetImages } from "constants";

import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import SaveMedicalConsent from "./Popup/SaveMedicalConsent";
import MedicalConsentDetails from "./Popup/MedicalConsentDetails";
import { mergeListById, consentOptions } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import MedicalConsentFilter from "./Popup/MedicalConsentFilter";

const MedicalConsentSection = () => {
  const params = useParams();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(false);
  const [consentList, setConsentList] = useState([]);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedConsentIds, setSelectedConsentIds] = useState([]);
  const [selectedConsentId, setSelectedConsentId] = useState(null);

  //function for get all consent
  const getAllConsent = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MEDICAL_CONSENTS +
        `?token=${token}&filterowner=${params.id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in get all consent", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        setConsentList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setConsentList((prevList) => mergeListById(prevList, data));
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllConsent();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllConsent();
      setReloadData(false);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#medicalConsentDetailsOffCanvas"
            aria-controls="medicalConsentDetailsOffCanvas"
            onClick={() => {
              setSelectedConsentId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Granted To",
        accessorKey: "authorizedusername",
        Cell: ({ row }) => (
          <div
            className={
              row.original.authorizedusername === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.authorizeduserimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.authorizeduserimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.authorizedusername}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Authorized Facility",
        accessorKey: "facilityname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.facilityname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.facilityimage === ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.facilityimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.facilityname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Consent Type",
        accessorKey: "recordcategory",
        Cell: ({ row }) => {
          const option = consentOptions.find(
            (opt) => opt.value === row.original.recordcategory
          );
          return <p>{option ? option.label : row.original.recordcategory}</p>;
        },
      },
      {
        header: "Purpose",
        accessorKey: "purpose",
      },
      {
        header: "Duration",
        accessorKey: "duration",
        // Cell: ({ row }) => (
        //   <div className="badge rounded-pill bg-primary text-white px-3 py-2">
        //     {row.original.duration}
        //   </div>
        // ),
      },
      {
        header: "Status",
        accessorKey: "consentstatus",
        // Cell: ({ row }) => (
        //   <div
        //     className={`badge rounded-pill text-white px-3 py-2 ${
        //       row.original.isactive === true ? "bg-success" : "bg-danger"
        //     }`}
        //   >
        //     {row.original.consentstatus}
        //   </div>
        // ),
      },
      {
        header: "Created Date",
        accessorKey: "createddate",
      },
    ],
    []
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedConsentIds(selectedIdsArray); // Renamed
    } else {
      setSelectedConsentIds([]); // Renamed
    }
  }, [rowSelection]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center mb-4">
          <div className="col-lg-4">
            <h3 className="mb-0">Medical Consent</h3>
          </div>
          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>
            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#medicalConsentFilterOffCanvas"
              aria-controls="medicalConsentFilterOffCanvas"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#saveMedicalConsentOffCanvas"
              aria-controls="saveMedicalConsentOffCanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>

      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={consentList}
            enableGrouping
            enableRowSelection
            getRowId={(row) => row._id}
            onRowSelectionChange={setRowSelection}
            state={{ rowSelection, columnOrder }}
            initialState={{ rowSelection, columnOrder }}
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      <SaveMedicalConsent
        afterActionClose={afterActionClose}
        selectedConsentId={selectedConsentId}
        setSelectedConsentId={setSelectedConsentId}
      />

      <MedicalConsentDetails
        selectedConsentId={selectedConsentId}
        setSelectedConsentId={setSelectedConsentId}
        afterActionClose={afterActionClose}
      />

      <MedicalConsentFilter
        moduleSlug="medicalconsent"
        setJsonFilterQuery={setJsonFilterQuery}
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        reloadList={resetFilterData}
      />
    </div>
  );
};

export default MedicalConsentSection;
